export type ExecRouteProps = {
    path: string,
    exec: () => void
}
export const ExecRoute = ({path, exec}: ExecRouteProps): preact.VNode | null => {
    exec()
    return null
} 